module.exports = __webpack_public_path__ + "static/media/check-icon.35854068.svg";